module.exports = __webpack_public_path__ + "img/gred.575b4436.png";